/**
 * Whether a plan block may still be confirmed. The server holds exactly one proposal open and
 * withdraws it on every change of the conversation; a withdrawn block reads only and says so.
 * A chip change still pending locally counts as a change already.
 *
 * @param {object} block - The plan block (`proposalSeq`, `withdrawn`, `confirmed`)
 * @param {object} state
 * @param {number|null} state.openProposalSeq - The proposal the server holds open
 * @param {boolean} state.mandatePending - A chip change not yet persisted
 * @param {boolean} state.working
 * @param {boolean} state.cancelled
 * @returns {{active: boolean, stale: boolean}} `stale`: overtaken, the assistant has to plan again
 */
export function planState(block, { openProposalSeq, mandatePending, working, cancelled }) {
	const open = openProposalSeq === block.proposalSeq && !block.confirmed;
	const stale = Boolean(block.withdrawn) || (open && mandatePending);
	return { active: open && !stale && !working && !cancelled, stale };
}
